module.exports = __webpack_public_path__ + "img/pro 10.612a938d.jpg";